export interface AsyncRouteItem {
    path: string;
    name?: string;
    component?: string;
    redirect?: string;
    meta?: {
        title?: string;
        icon?: string;
        roles?: string[];
        hidden?: boolean;
        affix?: boolean;
        keepAlive?: boolean;
        order?: number;
    };
    children?: AsyncRouteItem[];
}

export interface AsyncMenuResponse {
    code: number;
    message: string;
    data: AsyncRouteItem[];
}

/**
 * 获取后台动态路由/菜单接口
 * 目前后端无真实接口时返回空数组，支持未来随时无缝接入真实接口
 */
export function getAdminAsyncRoutesApi(): Promise<AsyncMenuResponse> {
    return Promise.resolve({
        code: 200,
        message: "success",
        data: []
    });
}
